import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'
import { DataTableLoading } from '@root/shared/ui-kit/data-table/ui/data-table-loading'

type Props = {
  columnsCount?: number
}
export const StatisticsTablesSkeleton: React.FC<Props> = ({
  columnsCount = 7,
}) => (
  <Root>
    <Header>
      {Array.from({ length: columnsCount }).map((_, index) => (
        <Skeleton key={index} height={6} />
      ))}
    </Header>
    <Body>
      <Loading />
    </Body>
  </Root>
)

const Root = styled.div`
  display: grid;
  grid-template-rows: 26px 1fr;
  height: 100%;
`

const Header = styled.div`
  background-color: var(--background-2);

  display: grid;
  padding-inline: 16px;
  grid-auto-flow: column;
  gap: 50px;

  place-items: center;
`

const Body = styled.div`
  display: grid;
`

const Loading = styled(DataTableLoading)`
  padding: 16px;
`
